<template>
  <a-modal :title="title"
           :width="800"
           :visible="visible"
           :confirmLoading="confirmLoading"
           @ok="handleOk"
           @cancel="handleCancel"
           :cancelText="$t('button.close')"
           wrapClassName="ant-modal-cust-warp"
           style="top: 5%; height: 85%; overflow-y: hidden">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.roleName">
          <a-input v-decorator="['roleName', validatorRules.roleName]"
                   :read-only="checkField('roleName')"
                   @click="openLangModal('roleName', true)"
                   :placeholder="$t('label.pleaseEnterRoleName')" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.roleCode">
          <a-input :placeholder="$t('label.pleaseEnterRoleCode')"
                   :disabled="roleDisabled"
                   v-decorator="['roleCode', validatorRules.roleCode]" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.description">
          <a-textarea v-decorator="['description', validatorRules.description]"
                      :read-only="checkField('description')"
                      @click="openLangModal('description', true)"
                      :rows="5"
                      :placeholder="$t('label.description')" />
        </mtc-form-item>
      </a-form>
    </a-spin>
    <mtc-lang-modal />
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addRole, editRole, duplicateCheck } from '@/api/api'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'

export default {
  name: 'RoleModal',
  mixins: [mtcLangModalMixin, langInputMixin],
  data() {
    return {
      title: '操作',
      visible: false,
      roleDisabled: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      // form: this.$form.createForm(this),
      validatorRules: {
        roleName: {
          rules: [
            { required: true, message: this.$t('label.pleaseEnterRoleName') },
            { min: 2, max: 30, message: this.$t('label.twoToThirtyCharactersInLength'), trigger: 'blur' }
          ]
        },
        roleCode: {
          rules: [
            { required: true, message: this.$t('label.pleaseEnterRoleCode') },
            { min: 0, max: 64, message: this.$t('label.upToSixtyFourCharactersInLength'), trigger: 'blur' },
            { validator: this.validateRoleCode }
          ]
        },
        description: {
          rules: [{ min: 0, max: 126, message: this.$t('label.LessThanCharacters_126'), trigger: 'blur' }]
        }
      },
      mainTable: 'sys_role'
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.getLangForm(this.mainTable)
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true

      //编辑页面禁止修改角色编码
      if (this.model.id) {
        this.roleDisabled = true
      } else {
        this.roleDisabled = false
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'roleName', 'description', 'roleCode'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          values.roleName = (values.roleName || '').trim()
          values.roleCode = (values.roleCode || '').trim()
          let formData = Object.assign(this.model, values)
          let obj
          console.log(formData)
          // 设置数据多语言参数
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          if (!this.model.id) {
            obj = addRole
          } else {
            obj = editRole
          }
          that.confirmLoading = true
          obj(formData).then((res) => {
            if (res.success) {
              resetLangFieldMap()
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateRoleCode(rule, value, callback) {
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback(this.$t('label.noChineseCharactersAllowed'))
      } else {
        var params = {
          tableName: 'sys_role',
          fieldName: 'role_code',
          fieldVal: value,
          dataId: this.model.id
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      }
    }
  }
}
</script>